import React from "react";
import "./DetailTitle.scss";
import ClipBoardButton from "components/ClipBoardButton/ClipBoardButton";
import TypeButton from "components/TypeButton/TypeButton";
import Date from "components/Date/Date";

type Props = {
  title: string;
  date: string;
  type: string;
};

const DetailTitle: React.FC<Props> = ({ title, date, type }) => {
  return (
    <div className="DetailTitle">
      <TypeButton type={type} isDetail />
      <Date isDetail>{date}</Date>
      <h3>{title}</h3>
      <ClipBoardButton />
    </div>
  );
};

export default DetailTitle;
